/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Send_During_Embedding_DescriptionInputs */



/**
* | output |
* | --- |
* | "Some attached files are still being embedded. The AI won't have access to their contents yet. Send anyway?" |
*
* @param {Chat_Send_During_Embedding_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_send_during_embedding_description = /** @type {((inputs?: Chat_Send_During_Embedding_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Send_During_Embedding_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einige angehängte Dateien werden noch eingebettet. Die KI hat noch keinen Zugriff auf deren Inhalte. Trotzdem senden?")
	return /** @type {LocalizedString} */ ("Some attached files are still being embedded. The AI won't have access to their contents yet. Send anyway?")
});